<template>
  <div class="content">
    <vsmallheader></vsmallheader>
    <div class="score-box">
      <div class="paper-box">
        <el-input
          v-model="inputName"
          placeholder="请输入姓名"
          size="small"
          style="width: 200px; "
          clearable
          @change="SelectExamUser()"
        ></el-input>
        <el-input
          v-model="inputCode"
          placeholder="请输入警号"
          size="small"
          style="width: 200px; margin-left: 10px"
          clearable
          @change="SelectExamUser()"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 10px"
          @click="SelectExamUser()"
        >搜索</el-button>
      </div>
      <el-table
        :data="ExaminersTable"
        id="examinersTable"
        border
        height="100%"
        style="width: 100%; margin-top: 10px; font-size: 18px;"
      >
        <el-table-column fixed prop="name" label="姓名" align="center" min-width="150"></el-table-column>

        <el-table-column prop="sex" label="性别" align="center" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.sex ">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>

        <el-table-column prop="code" label="警号" align="center" min-width="150" sortable></el-table-column>

        <el-table-column prop="sumScore" label="分数" align="center" min-width="100" sortable></el-table-column>

        <el-table-column prop="minute" label="作答时间" align="center" min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.minute}}</span>
            <span>分钟</span>
          </template>
        </el-table-column>

        <el-table-column prop="deptName" label="所在单位" align="center" min-width="300"></el-table-column>

        <el-table-column prop="isCorrect" label="是否批改" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCorrect" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="isSubmit" label="是否提交" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSubmit" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" min-width="150" align="center">
          <template slot-scope="scope">
            <el-button @click="SelectQuestion(scope.row)" type="text">查看结果</el-button>
            <el-button @click="reviewPaper(scope.row)" type="text">复核试卷</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="dataCount"
        style="text-align: center; padding-top: 15px"
      ></el-pagination>
    </div>
    <!-- 查看结果弹框 -->
    <el-dialog
      :v-el-drag-dialog="false"
      class="dialog-mini"
      width="92%"
      top="0"
      :title="textMap2[dialogStatus]"
      :visible.sync="dialogVisible2"
      :before-close="handleClose2"
      :close-on-click-modal="false"
    >
      <div style="display: flex" id="pdfDom">
        <!-- 答题卡区域 -->
        <div class="leftPreview">
          <el-scrollbar style="height: 100%">
            <div style="width: 250px">
              <div class="title2">
                <i class="el-icon-date"></i>&nbsp;&nbsp;答题卡
              </div>
              <div class="leftimg" v-if="abc == ''">
                <!-- <img src="../../assets/images/exam/暂无数据.png" /> -->
                <br />
                <span style="color: #b2b8bd; margin-left: 4px">暂无数据</span>
              </div>
              <div class="leftdiv" v-if="examList !== ''">
                <span class="allscore-text">总分：{{allScore}}</span>
              </div>
              <div class="nr" v-if="dxt != 0">
                <span style="padding-left: 22px">单选题</span>
                <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="dxt != 0">
                <div style="display: flex; flex-wrap: wrap;">
                  <div
                    v-for="(item, index1) in abc"
                    :key="index1"
                    @click="jump(item.title)"
                    v-if="item.type == 1"
                  >
                    <div :class="['top',item.isRight ? 'top-true':'top-false']">
                      <span
                        style="
                            padding-left: 6px;
                            font-size: 14px;
                            color: white;
                          "
                      >{{ index1 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="ddxt != 0">
                <span style="padding-left: 22px">多选题</span>
                <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="ddxt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index2) in abc"
                    :key="index2"
                    @click="jump(item.title)"
                    v-if="item.type == 2"
                  >
                    <div :class="['top',item.isRight ? 'top-true':'top-false']">
                      <span
                        style="
                            padding-left: 6px;
                            font-size: 14px;
                            color: white;
                          "
                      >{{ index2 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="pdt != 0">
                <span style="padding-left: 22px">判断题</span>
                <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="pdt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index3) in abc"
                    :key="index3"
                    @click="jump(item.title)"
                    v-if="item.type == 3"
                  >
                    <div :class="['top',item.isRight ? 'top-true':'top-false']">
                      <span
                        style="
                            padding-left: 6px;
                            font-size: 14px;
                            color: white;
                          "
                      >{{ index3 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="tkt != 0">
                <span style="padding-left: 22px">填空题</span>
                <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="tkt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index5) in abc"
                    :key="index5"
                    @click="jump(item.title)"
                    v-if="item.type == 4"
                  >
                    <div :class="['top',item.isRight ? 'top-true':'top-false']">
                      <span
                        style="
                            padding-left: 6px;
                            font-size: 14px;
                            color: white;
                          "
                      >{{ index5 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="wdt != 0">
                <span style="padding-left: 22px">问答题</span>
                <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="wdt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index4) in abc"
                    :key="index4"
                    @click="jump(item.title)"
                    v-if="item.type == 5"
                  >
                    <div :class="['top',item.isRight ? 'top-true':'top-false']">
                      <span
                        style="
                            padding-left: 6px;
                            font-size: 14px;
                            color: white;
                          "
                      >{{ index4 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!-- 题目区域 -->
        <div class="zhuti">
          <div class="title" v-if="dxt != 0">
            <span style="padding-left: 30px">单选题</span>
            <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum }}分)</span>
          </div>
          <div v-for="(item, index) in abc" :key="index" v-if="item.type == 1 ">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index + 1 }}.</span>
                  <span v-html="item.title" :id="item.title"></span>
                </div>
                <div>
                  <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                    <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index)">
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="标记" placement="top">
                    <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index)">
                      <use xlink:href="#iconmark" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>
              <div>
                <ul>
                  <li v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                    <label :for="items.Id" style="font-size: 15px">
                      <input type="radio" v-model="item.value" :value="items.Id" disabled />
                      {{ items.Name }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="correct" v-if="item.answer[index]">
                <span v-if="item.isRight">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px;"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px;"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                  <span v-if="indexs == 0 && items.IsRight == true">正确答案：A</span>
                  <span v-if="indexs == 1 && items.IsRight == true">正确答案：B</span>
                  <span v-if="indexs == 2 && items.IsRight == true">正确答案：C</span>
                  <span v-if="indexs == 3 && items.IsRight == true">正确答案：D</span>
                </div>
                <div
                  style="margin-left: 40px;"
                  v-for="(items, indexs12) in item.answer"
                  :key="indexs12"
                  :id="items.Name"
                >
                  <span v-if="indexs12 == 0 && items.IsCheck == true">我选择的答案：A</span>
                  <span v-if="indexs12 == 1 && items.IsCheck == true">我选择的答案：B</span>
                  <span v-if="indexs12 == 2 && items.IsCheck == true">我选择的答案：C</span>
                  <span v-if="indexs12 == 3 && items.IsCheck == true">我选择的答案：D</span>
                </div>
                <div style="margin-left: 40px">
                  <span v-if="item.value == ''">你选择的答案：未作答</span>
                </div>
              </div>
              <div class="dispright" style=" color: #1b89ce">
                <span></span>
                <span>得分：{{item.winScore}}</span>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{item.explain}}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="ddxt != 0">
            <span style="padding-left: 30px">多选题</span>
            <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span>
          </div>
          <div v-for="(item1, index1) in abc" :key="index1" v-if="item1.type == 2">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index1 + 1 }}.</span>
                  <span v-html="item1.title" :id="item1.title"></span>
                </div>
                <div>
                  <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                    <svg v-if="item1.bjStatus == true" class="icon">
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="标记" placement="top">
                    <svg v-if="item1.bjStatus == false" class="icon">
                      <use xlink:href="#iconmark" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>
              <div>
                <ul>
                  <li v-for="(items, indexs1) in item1.answer" :key="indexs1" :id="items.Name">
                    <input type="checkbox" v-model="items.IsCheck" :value="items.Id" disabled />
                    <label :for="items.Id" style="font-size: 15px">
                      {{
                      items.Name
                      }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="correct" v-if="item1.answer">
                <span v-if="item1.isRight">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px;"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px;"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div class="rightanswer">
                  <div>正确答案：</div>
                  <div v-for="(items, indexs) in item1.answer" :key="indexs">
                    <span v-if="indexs == 0 && items.IsRight == true">A</span>
                    <span v-if="indexs == 1 && items.IsRight == true">B</span>
                    <span v-if="indexs == 2 && items.IsRight == true">C</span>
                    <span v-if="indexs == 3 && items.IsRight == true">D</span>
                  </div>
                </div>
                <div class="mychange">
                  <div v-if="item1.MyCate != ''">我选择的答案：</div>
                  <div v-for="(items, indexs2) in item1.answer" :key="indexs2">
                    <span v-if="indexs2 == 0 && items.IsCheck == true">A</span>
                    <span v-if="indexs2 == 1 && items.IsCheck == true">B</span>
                    <span v-if="indexs2 == 2 && items.IsCheck == true">C</span>
                    <span v-if="indexs2 == 3 && items.IsCheck == true">D</span>
                  </div>
                </div>
                <div class="mychange" v-if="item1.MyCate == ''">
                  <span>我选择的答案：未作答</span>
                </div>
              </div>
              <div class="dispright" style=" color: #1b89ce">
                <span></span>
                <span>得分：{{item1.winScore}}</span>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{item1.explain}}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="pdt != 0">
            <span style="padding-left: 30px">判断题</span>
            <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum }}分)</span>
          </div>
          <div v-for="(item, index2) in abc" :key="index2" v-if="item.type == 3">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index2 + 1 }}.</span>
                  <span v-html="item.title" :id="item.title"></span>
                </div>
                <div>
                  <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                    <svg v-if="item.bjStatus == true" class="icon">
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="标记" placement="top">
                    <svg v-if="item.bjStatus == false" class="icon">
                      <use xlink:href="#iconmark" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>
              <div style="padding-left: 35px; line-height: 50px">
                <input :name="item.id" type="radio" disabled />
                <label style="font-size: 15px">对</label>
                <input :name="item.id" type="radio" style="margin-left: 20px" disabled />
                <label style="font-size: 15px">错</label>
              </div>
              <div class="correct" v-if="item.answer">
                <span v-if="item.isRight == true">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px;"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px;"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                  <span v-if="items.IsRight == true">正确答案：正确</span>
                  <span v-if="items.IsRight == false">正确答案：错误</span>
                </div>
                <div
                  v-for="(items, indexs2) in item.answer"
                  :key="indexs2"
                  :id="items.Name"
                  style="margin-left: 40px"
                >
                  <span v-if="items.IsCheck == true">你选择的答案：正确</span>
                  <span v-else-if="items.IsCheck == false">你选择的答案：错误</span>
                  <span v-else>你选择的答案：无</span>
                </div>
              </div>
              <div class="dispright" style=" color: #1b89ce">
                <span></span>
                <span>得分：{{item.winScore}}</span>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{ item.explain }}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="tkt != 0">
            <span style="padding-left: 30px">填空题</span>
            <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum }}分)</span>
          </div>
          <div v-for="(item, index4) in abc" :key="index4" v-if="item.type == 4">
            <div class="hhh">
              <div class="sss">
                <!-- <div :id="item.title">{{ index4 + 1 }}.{{ item.title }}</div> -->
                <div class="subject">
                  <span>{{ index4 + 1 }}.</span>
                  <span v-html="item.title" :id="item.title"></span>
                </div>
                <div>
                  <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                    <svg v-if="item.bjStatus == true" class="icon">
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="标记" placement="top">
                    <svg v-if="item.bjStatus == false" class="icon">
                      <use xlink:href="#iconmark" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>

              <div>
                <el-input
                  v-for="(items, indexs2) in item.answer"
                  disabled
                  :key="indexs2"
                  v-model="items.letter"
                  placeholder="请输入内容"
                  style="
                    width: 95%;
                    padding-left: 30px;
                    padding-top: 10px;
                    padding-bottom: 20px;
                  "
                >
                  <template slot="prepend">{{ indexs2 + 1 }}</template>
                </el-input>
              </div>
              <div class="correct" v-if="item.answer">
                <span v-if="item.isRight">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px;"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px;"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div
                  class="answer-true"
                  v-for="(items, indexs) in item.answer"
                  :key="indexs"
                  style="width: 100%"
                >
                  <p :title="items.Name">正确答案：{{ items.Name }}</p>
                </div>
              </div>
              <div class="dispright" style=" color: #1b89ce">
                <span></span>
                <span>得分：{{item.winScore}}</span>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{item.explain}}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="wdt != 0">
            <span style="padding-left: 30px">问答题</span>
            <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum }}分)</span>
          </div>
          <div v-for="(item, index3) in abc" :key="index3" v-if="item.type == 5">
            <div class="hhh">
              <div class="sss">
                <!-- <div :id="item.title">{{ index3 + 1 }}.{{ item.title }}</div> -->
                <div class="subject">
                  <span>{{ index3 + 1 }}.</span>
                  <span v-html="item.title" :id="item.title"></span>
                </div>
                <div>
                  <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                    <svg v-if="item.bjStatus == true" class="icon">
                      <use xlink:href="#iconbiaoji" />
                    </svg>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="标记" placement="top">
                    <svg v-if="item.bjStatus == false" class="icon">
                      <use xlink:href="#iconmark" />
                    </svg>
                  </el-tooltip>
                </div>
              </div>
              <div>
                <el-input
                  disabled
                  v-for="(items, indexs2) in item.answer"
                  :key="indexs2"
                  v-model="items.letter"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  style="
                      width: 95%;
                      padding-left: 30px;
                      padding-top: 10px;
                      padding-bottom: 20px;
                    "
                ></el-input>
              </div>
              <div class="answer">
                <div v-for="(items, indexs) in item.answer" :key="indexs" class="right-key">
                  <span :title="items.Name">正确答案：{{ items.Name }}</span>
                </div>
              </div>
              <div class="dispright" style=" color: #1b89ce">
                <span></span>
                <span>得分：{{item.winScore}}</span>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{item.explain}}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
        <!-- 考试信息区域 -->
        <div class="rightPreview">
          <el-scrollbar style="height: 100%">
            <div style="width: 120px; padding:0 10px; box-sizing:border-box;">
              <div class="xinxi-box">
                <span class="text">考试成绩</span>
                <span class="core" v-if="allWinScore<allScore*0.6">{{ allWinScore }}分</span>
                <span class="core-pass" v-if="allWinScore>=allScore*0.6">{{ allWinScore }}分</span>
              </div>
              <div class="xinxi-box">
                <span class="text">考试状态</span>
                <span class="core-text" v-if="allWinScore<allScore*0.6">未通过</span>
                <span class="core-success" v-if="allWinScore>=allScore*0.6">通过</span>
              </div>
              <div class="xinxi-box">
                <span class="text">筛选试题</span>
                <span class="selectAll">
                  <el-select v-model="valueSelect.value" @change="previewSelect(valueSelect.value)">
                    <el-option
                      v-for="item in optionSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="font-size: 14px;">{{ item.label }}</span>
                      <i style="font-size: 14px; padding-left: 20px;" class="el-icon-check"></i>
                    </el-option>
                  </el-select>
                </span>
              </div>
              <div class="close">
                <el-button type="primary" @click="closeJGDialog">关闭</el-button>
              </div>
              <!-- <div class="outpdf">
                  <el-button type="primary"  @click="getPdf">导出试卷</el-button>
              </div>-->
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
    <!-- 复核试卷弹框 -->
    <el-dialog
      class="dialog-mini"
      width="92%"
      top="0"
      :title="textMap2[dialogStatus]"
      :visible.sync="dialogVisible3"
      :before-close="handleClose3"
      :close-on-click-modal="false"
    >
      <ReviewPaper
        v-if="dialogVisible3"
        :processId="processId"
        :ExamId="ExamId"
        @closeDialog="closeDia"
        :userId="userId"
        :reviewPaperId="reviewPaperId"
      ></ReviewPaper>
    </el-dialog>
  </div>
</template>

<script>
import ReviewPaper from './reviewPaper'; //复核试卷弹框
import vsmallheader from '@/views/smallHeader/index';
import {
  examOpen,
  SelectUser,
  examFreeze,
  GetExamTJInfo,
} from '@/api/exam/exam';
import {
  SelectExam,
  SelectExamUser,
  SelectDrillMaster,
  SelectPaperQuestion,
  delExam,
} from '@/api/exam/achievement';
export default {
  components: {
    ReviewPaper,
    vsmallheader,
  },
  data() {
    return {
      inputName: null,
      inputCode: null,
      pageIndex: 1,
      pageSize: 10,
      textMap2: {
        0: '查看结果',
        1: '复核试卷',
        2: '复核人',
      },
      dialogStatus: '',
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      //数据
      abc: [],
      answer: '',
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      activeNames: ['1'], //折叠面板
      multipleSelection: [], // 列表checkbox选中的值
      allWinScore: 0,
      optionSelect: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '答对',
        },
        {
          value: 2,
          label: '答错',
        },
      ],
      valueSelect: {
        value: 0,
      },
      dataCount: 0,
      ExaminersTable: [],
      reviewPaperId: 0, //复核试卷id
      processId: 0, //过程id
      userId: 0,
      ExamId: 0,
    };
  },
  created() {
    this.valueSelect.value = this.optionSelect[0].value;
    this.ExamId = this.$route.query.id;
    this.SelectExamUser();
  },
  methods: {
    //关闭结果弹窗
    closeJGDialog() {
      this.dialogVisible2 = false;
    },
    closeDia(flag) {
      this.dialogVisible3 = flag;
    },
    jump(domId) {
      this.$nextTick(() => {
        const returnEle = document.getElementById(domId);
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      });
    },
    //监听筛选的类型
    previewSelect(value) {
      if (value == 0) {
        this.previewValue = null;
      } else if (value == 1) {
        this.previewValue = true;
      } else if (value == 2) {
        this.previewValue = false;
      }
    },
    //批量删除
    delBatch() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '至少删除一个',
          type: 'error',
        });

        return false;
      }
      delExam(this.multipleSelection.map((u) => u.id)).then(() => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000,
        });
        this.multipleSelection.forEach((row) => {
          const index = this.ExamList.indexOf(row);
          this.ExamList.splice(index, 1);
        });
        let total = this.total;
        let num = total - Number(this.multipleSelection.length);
        this.total = num;
      });
    },
    //
    rowClick(row) {
      this.$refs.mainTable.clearSelection();
      this.$refs.mainTable.toggleRowSelection(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange1(val) {
      this.pageIndex = val;
      this.SelectExamUser();
    },
    handleSizeChange1(val) {
      this.pageSize = val;
      this.SelectExamUser();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    SelectExamUser() {
      if (this.inputCode == '' || this.inputName == '') {
        this.inputCode = null;
        this.inputName = null;
      }
      let para = {
        examId: this.ExamId,
        userName: this.inputName,
        // userCode: this.inputCode,
        IsSubmit: true,
        page: this.pageIndex,
        limit: this.pageSize,
      };
      SelectUser(para).then((res) => {
        this.ExaminersTable = res.data;
        this.dataCount = res.count;
        for (let i = 0; i < this.ExaminersTable.length; i++) {
          this.ExaminersTable[i].status = true;
        }
      });
    },

    SelectQuestion(row) {
      this.userId = row.userId;
      this.dxt = 0;
      this.tkt = 0;
      this.pdt = 0;
      this.wdt = 0;
      this.ddxt = 0;
      this.dxtSum = 0;
      this.tktSum = 0;
      this.pdtSum = 0;
      this.wdtSum = 0;
      this.ddxtSum = 0;
      this.allWinScore = 0;
      this.dialogVisible2 = true;
      this.abc = [];
      let para = {
        examId: this.ExamId,
        userId: row.userId,
      };
      SelectPaperQuestion(para).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].CheckAnswer = [];
          if (res.data[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.data[i].score;
          } else if (res.data[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.data[i].score;
          } else if (res.data[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += res.data[i].score;
          } else if (res.data[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += res.data[i].score;
          } else if (res.data[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.data[i].score;
          }
          this.allWinScore += res.data[i].winScore;
        }
        this.allScore = Number(
          this.dxtSum + this.ddxtSum + this.pdtSum + this.wdtSum + this.tktSum
        );
        this.abc = res.data;
      });
    },
    //复核试卷
    reviewPaper(row) {
      this.processId = row.processId;
      this.userId = row.userId;
      this.reviewPaperId = this.ExamId;
      this.dialogVisible3 = true;
      this.dialogStatus = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.score-box {
  width: 1200px;
  margin: 0 auto;
  height: 75%;
  padding: 20px 0;
}
.content {
  height: 900px;
}
.container {
  background: #eff3f7;
}
.yiceng {
  padding-top: 10px;
  padding-left: 30px;
  width: calc(100vw - 300px);
  display: flex;
}
.table {
  width: 98%;
  padding-top: 10px;
  padding-left: 30px;
}
.cheat {
  padding-left: 20px;
}
.leftPreview {
  position: sticky;
  top: 20px;
  height: 600px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin-left: 10px;
}
.rightPreview {
  position: sticky;
  top: 20px;
  height: 420px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin: 0 10px;
}
.zhuti {
  width: 80%;
  background-color: white;
  margin-left: 2%;
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-radius: 5px;
}
.leftdiv {
  width: 210px;
  border-bottom: 1px solid rgb(226, 223, 223);
  margin-left: 20px;
}
.title2 {
  font-weight: bold;
  height: 40px;
  padding-top: 5px;
  padding-left: 20px;
  font-size: 18px;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
.nr {
  font-size: 10px;
  padding-top: 20px;
  padding-left: 5px;
}
.xinxi-box {
  font-size: 14px;
  padding: 20px 0;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dedede;
}
.xinxi-box .core {
  margin-top: 10px;
  font-size: 18px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-pass {
  margin-top: 10px;
  font-size: 18px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .core-text {
  margin-top: 10px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-success {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .selectAll {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.nav-con {
  width: 100%;
  height: 350px;
  border: 1px solid #f1f3f8;
  border-radius: 5px;
  margin-top: 20px;
}
.nav-con-child {
  color: #b2b8bd;
  margin-left: 45%;
  margin-top: 100px;
}
.leftimg {
  margin-left: 80px;
  margin-top: 200px;
}
.title {
  height: 55px;
  padding-top: 15px;
  font-size: 18px;
  font-weight: bold;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
li {
  padding-left: 40px;
  list-style: none;
  padding-bottom: 15px;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 70px;
  margin-right: 20px;
}
.hhh {
  border: 1px solid rgb(226, 223, 223);
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
}
.aaa {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: #1a8cfe;
}
.top {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: gray;
  border-radius: 2px;
}
.top-true {
  background-color: #1a8cfe;
}
.top-false {
  background-color: red;
}
.bottom {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #f1f3f8;
  border-radius: 2px;
  margin-right: 15px;
}
.analysis {
  width: 92%;
  margin-left: 4%;
  line-height: 40px;
}
.answer {
  display: flex;
  width: 92%;
  margin-left: 4%;
  /* border-top: 1px dashed rgb(226, 223, 223); */
  line-height: 40px;
}
.correct {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
  font-size: 16px;
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.subject {
  display: flex;
  align-items: baseline;
}
.right-key {
  width: 80%;
  padding-right: 20px;
}
.dispright {
  padding: 0 80px;
  display: flex;
  justify-content: space-between;
  // width: 100%;
}
.close {
  padding: 10px 20px;
}
.paper-box {
  padding: 0 10px;
}
.allscore-text {
  font-size: 20px;
  font-weight: 600;
  padding: 10px;
}
</style>